var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('heroSection'),_c('categorieSection'),_c('eventSection'),_c('articleHomeSection'),_c('partnersSection'),_c('instagramSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }